// extracted by mini-css-extract-plugin
export default {"actionButton":"RoomCommissionActions_actionButton__pDDkN"};